import { Time } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { PaginationInstance } from 'ngx-pagination';

@Component({
  selector: 'app-job-insight-details',
  templateUrl: './job-insight-details.component.html',
  styleUrls: ['./job-insight-details.component.scss']
})
export class JobInsightDetailsComponent {

  public objData = {
    user: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 1,
    },
  };
  public pageSizeOptions = GlobalService.pageSizeOptions;


  public dataSourceJobInsight: any[] = [];
  displayedColJobInsight: string[] = ["name", "total_shift", "total_hour"];
  public searchInput: string = '';
  private previousInputValue: string = '';
  isSpinnerLoading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private timeClockService: TimeClockService,
    private appService: AppService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getDetails()
  }

  getDetails() {
    let data = {
      "ed_dt": this.dialogData?.ed_dt,
      "f_a": [],
      "op_nd": "or",
      "sh": this.searchInput.trim(),
      "st_dt": this.dialogData?.st_dt,
      "tc_id": this.dialogData?.tc_id,
      "type": "0",
      "j_c": this.dialogData?.j_c,
      "j_sc": this.dialogData?.j_sc,
      r_p: this.objData.user.itemsPerPage,
      st: this.appService.startPageLogic(
        this.objData.user.currentPage,
        this.objData.user.itemsPerPage
      ),
    }
    this.isSpinnerLoading = true;
    this.timeClockService.getSpecificInsightSubC(data).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false
        this.previousInputValue = this.searchInput.trim();
        this.dataSourceJobInsight = []
        this.dataSourceJobInsight = success.msg;
        this.objData.user.count = success.count;
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        this.previousInputValue = this.searchInput.trim();
        this.dataSourceJobInsight = []
        this.commonService.handleError(error);
      },
    });
  }


  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.getDetails();
    }
  }

  onGo() {
    if (this.searchInput.trim() != '') {
      this.getDetails();
    }
  }
  onPageSizeChange(event: Event, type: string) {
    const tar = event.target as HTMLInputElement;
    this.objData[type].itemsPerPage = Number(tar.value);
    this.objData[type].currentPage = 1;
    this.getDetails();
  }
  onPageChange(number: number, type: string) {
    this.objData[type].currentPage = number;
    this.getDetails();
  }
}
